import { SearchResultEnriched } from 'lib-search-types';

import { searchApi } from 'apis/search';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { SearchViewScope } from '../../search.types';

import { SearchResultsEmpty } from './components/empty/searchResultsEmpty';
import { SearchResultsLoading } from './components/loading/searchResultsLoading';
import { ContactsResults } from './components/types/contacts/contactsResults';
import { ConversationsResults } from './components/types/conversations/conversationsResults';
import styles from './searchResults.module.scss';

type SearchResultsProps = {
  onChangeScope: (scope: SearchViewScope) => void;
};

export const SearchResults = ({
  onChangeScope,
}: SearchResultsProps): JSX.Element => {
  const { params } = useAppSelector((state) => state.search);
  const { scope } = params;

  const { results, meta, isFetching } =
    searchApi.endpoints.readAdvancedSearchResults.useQueryState(
      { ...params, enrichmentSpec: 'ALL' },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          results: data?.data.results,
          meta: data?.meta,
        }),
      },
    );

  if (!results?.length) return <SearchResultsEmpty />;

  return (
    <div className={styles.root}>
      {isFetching && <SearchResultsLoading isOverlay />}

      {(scope as SearchViewScope) === 'conversations' && (
        <ConversationsResults
          results={results as readonly SearchResultEnriched<'conversations'>[]}
          meta={meta}
        />
      )}

      {(scope as SearchViewScope) === 'users' && (
        <ContactsResults
          scope="users"
          results={results as readonly SearchResultEnriched<'users'>[]}
          meta={meta}
          onChangeScope={onChangeScope}
        />
      )}

      {(scope as SearchViewScope) === 'companies' && (
        <ContactsResults
          scope="companies"
          results={results as readonly SearchResultEnriched<'companies'>[]}
          meta={meta}
          onChangeScope={onChangeScope}
        />
      )}
    </div>
  );
};
